import styled, { css } from 'styled-components';
import { always, ifElse, propEq } from 'ramda';
import ReactPlayer from 'react-player';

import { ASSET_PLACEMENT, CONTAINER_PADDING, CONTAINER_WIDTH } from '@components/blocks/blocks.constants';
import { media } from '@theme/media';

interface StylesProps {
  placement: ASSET_PLACEMENT;
}

export const Caption = styled.p`
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.02em;
`;

const normalVideoStyle = css`
  max-width: ${CONTAINER_WIDTH - 2 * CONTAINER_PADDING}px;
  margin: 4.2em auto 3.5em;
  ${Caption} {
    margin: 12px 0 0;
  }
`;

const wideVideoStyle = css`
  margin: 4.2em -${CONTAINER_PADDING}px 3.5em;
  ${Caption} {
    margin: 12px ${CONTAINER_PADDING}px 0;
  }
`;

const getVideoContainerStyles: ({ placement }: StylesProps) => string = ifElse(
  propEq('placement', ASSET_PLACEMENT.NORMAL),
  always(normalVideoStyle),
  always(wideVideoStyle)
);

export const Container = styled.div`
  margin: 0 ${CONTAINER_PADDING}px;

  ${media.tablet} {
    margin: 0 ${CONTAINER_PADDING * 1.5}px;
  }
`;

export const Content = styled.div`
  ${getVideoContainerStyles};

  ${media.tablet} {
    margin: 4.2em auto 3.5em;

    ${Caption} {
      margin: 12px 0 0;
    }
  }

  position: relative;
`;

export const VideoWrapper = styled.div`
  padding-top: 56.25%;
  position: relative;
`;

export const Player = styled(ReactPlayer)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
